import React, { ReactEventHandler, VFC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';

import DrawerListItem from '../molecules/DrawerListItem';
import { getMenus, TOOLBAR_SM_MIN_HEIGHT } from '../utils';

const ListWrapper = styled.div<{ theme: Theme }>`
  width: auto;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.common.white};
`;

const useStyles = makeStyles((theme) => ({
  toolbar: {
    zIndex: `${theme.zIndex.appBar - 10} !important` as any, // zIndexはnumberしか許容していないため、anyで型をつける
    top: `${TOOLBAR_SM_MIN_HEIGHT}px !important`,

    [theme.breakpoints.up('md')]: {
      top: `${theme.mixins.toolbar.minHeight}px !important`,
    },
  },
}));

interface Props {
  open: boolean;
  handleOpenSPDrawer: ReactEventHandler;
  handleCloseSPDrawer: ReactEventHandler;
}

const SPDrawer: VFC<Props> = ({
  open,
  handleOpenSPDrawer,
  handleCloseSPDrawer,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();
  const menus = getMenus(t);

  return (
    <SwipeableDrawer
      anchor="top"
      open={open}
      minFlingVelocity={800}
      elevation={0}
      onClose={handleCloseSPDrawer}
      onOpen={handleOpenSPDrawer}
      classes={{
        paperAnchorTop: classes.toolbar,
        modal: classes.toolbar,
      }}
    >
      <ListWrapper
        role="presentation"
        theme={theme}
        onClick={handleCloseSPDrawer}
        onKeyDown={handleCloseSPDrawer}
      >
        <List>
          <DrawerListItem {...menus.about} />
          <DrawerListItem {...menus.businesses} />
          <DrawerListItem {...menus.plans} />
          <DrawerListItem {...menus.diary} />
          <DrawerListItem {...menus.business} />
        </List>
      </ListWrapper>
    </SwipeableDrawer>
  );
};

export default SPDrawer;
